<script>
import { roleMethods, approverWorkflowMethods } from '@state/helpers'

export default {
  props: {
    approverworkflow: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      updateApproverOrderError: null,
      formError: null,
      isWorking: false,
      roleItems: [],
      roleSearchError: null,
      roleSearch: null,
      searchingRoles: false,
      selectedRole: null,
      approverDialog: false,
      approvers: this.approverworkflow,
    }
  },
  methods: {
    ...approverWorkflowMethods,
    ...roleMethods,
    close() {
      this.approverDialog = false
      this.selectedRole = null
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save() {
      if (!this.selectedRole) {
        this.$swal('Error', 'You must choose a role.', 'error')
        return
      }

      this.editedItem.roleId = this.selectedRole.id

      this.createApprover(this.editedItem)
        .then(response => {
          this.approvers.push(response)
          this.approverDialog = false
          this.selectedRole = null
        })
        .catch(error => {
          this.updateApproverOrderError = error
        })
    },
    searchRoles() {
      this.roleSearchError = null
      this.getRolesWithoutWorkflow({ search: this.roleSearch })
        .then(response => {
          this.roleItems = response.results
        })
        .catch(error => {
          this.roleSearchError = error
        })
    },
    confirmApproverDelete(approver) {
      this.$swal({
        title: 'Confirm',
        text: 'Are you sure you want to delete this workflow?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.value) {
          this.tryDeleteApprover(approver)
        }
      })
    },
    tryDeleteApprover(approver) {
      this.deleteApprover(approver)
        .then(response => {
          var index = this.approvers.indexOf(approver)
          if (index !== -1) {
            this.approvers.splice(index, 1)
          }
        })
        .catch(error => {
          this.$swal('Error', error.response.data, 'error')
        })
    },
    describeApprovalFlow(approver) {
      var desc = ''
      if (!approver.signoff || !approver.signoff.length) {
        return 'No Signoff Configured'
      }

      var unsorted = approver.signoff.slice(0)

      var sortedSignoff = unsorted.sort(function(a, b) {
        return a.order - b.order
      })

      for (var i = 0; i < sortedSignoff.length; i++) {
        desc += sortedSignoff[i].role.name
        if (i + 1 < sortedSignoff.length) {
          desc += ' => '
        }
      }

      return desc
    },
    editApprover(approver) {
      this.$router.push({
        name: 'editWorkflow',
        params: { workflowId: approver.id, workflow: approver },
      })
    },
  },
}
</script>

<template>
  <v-card>
    <!-- Table header -->
    <v-toolbar flat color="transparent">
      <v-toolbar-title>Approval Workflows</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        color="cyan"
        single-line
        hide-details
      ></v-text-field>

      <!-- Add workflow dialog -->
      <v-dialog v-model="approverDialog" max-width="500px">
        <v-btn slot="activator" color="cyan" dark depressed class="mb-2 ml-4"
          >Add Workflow</v-btn
        >
        <v-card class="px-3 py-2">
          <v-card-title>
            <span class="headline">Add Workflow</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md class="pa-0">
              <v-layout wrap>
                <v-flex xs12>
                  <v-combobox
                    v-model="selectedRole"
                    :items="roleItems"
                    :loading="searchingRoles"
                    :search-input.sync="roleSearch"
                    item-text="name"
                    item-value="id"
                    label="Requestor Role"
                    placeholder="Start typing to Search"
                    hint="Choose a role"
                    color="cyan"
                  ></v-combobox>
                </v-flex>
                <v-alert :value="formError" type="error">{{
                  formError
                }}</v-alert>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="cyan" dark depressed outline @click="close"
              >Cancel</v-btn
            >
            <v-btn color="cyan" dark depressed @click="save">
              <BaseIcon v-if="isWorking" name="sync" spin />
              <span v-else>Save</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <!-- Table -->
    <table class="table">
      <thead>
        <tr>
          <th>Requestor Role</th>
          <th>Approval Flow</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="approver in approvers"
          :key="approver.id"
          @click="editApprover(approver)"
        >
          <td>{{ approver.role.name }}</td>
          <td>{{ describeApprovalFlow(approver) }}</td>
          <td>
            <v-icon
              small
              class="mr-2"
              @click.prevent="confirmApproverDelete(approver)"
              >delete</v-icon
            >
          </td>
        </tr>
      </tbody>
    </table>
    <span v-if="!approvers.length">No Approvers</span>
  </v-card>
</template>
